import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { useAppDispatch, useAppSelector } from "reduxFiles/hooks";
import { removeNotification } from "reduxFiles/slices/notificationSlice";
import { Notification } from "types/globalTypes";

export default function Toaster() {
  const dispatch = useAppDispatch();
  const items = useAppSelector((state) => state.notifications.items);

  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = [];

    items.forEach((item: Notification) => {
      const timer = setTimeout(() => {
        dispatch(removeNotification(item.id));
      }, item.duration || 5000);

      timers.push(timer);
    });

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [items, dispatch]);

  if (!items.length) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[999999] flex flex-col gap-3">
      {items.map((item: Notification) => (
        <div
          key={item.id}
          className={`animate-slide-in group relative w-[300px] rounded-xl border p-4 pe-10 shadow-lg backdrop-blur-md transition-all duration-300
          ${
            item.type === "success"
              ? "border-green-500 bg-green-600/90"
              : item.type === "error"
              ? "border-red-400 bg-red-500/90"
              : item.type === "warning"
              ? "border-yellow-600 bg-yellow-600/90"
              : "border-blue-400 bg-blue-500/90"
          }`}
        >
          <div>
            <button
              onClick={() => dispatch(removeNotification(item.id))}
              className="absolute end-3 top-3 text-white/70 hover:text-white"
            >
              <IoMdClose size={20} />
            </button>

            {item.title && (
              <p className="mb-1 text-sm font-semibold text-white">
                {item.title}
              </p>
            )}
          </div>

          <p className="whitespace-pre-line text-sm text-white/90">
            {item.message}
          </p>

          <div className="absolute bottom-0 left-0 h-1 w-full overflow-hidden rounded-b-xl">
            <div className="animate-progress h-full w-full bg-white/30" />
          </div>
        </div>
      ))}
    </div>
  );
}
